module.exports = __webpack_public_path__ + "static/assets/30ae853b2aeb2191d4617369e25cb31d.svg";